import ECatalogPage from "./ecatlog.page"
export default ECatalogPage;
